$(document).ready(function() {
  if($('.pannel_calculator__inner .pannel_calculator-width').length > 0){
    let qty = 1;
    
    $('.pannel_calculator__inner .pannel_calculator-width').on('keyup', function() {
        let totalValue = 0;
        let panelval = 0;
      
        if($(this).parents('.productView-product').find('.pannel_calculator_main').length > 0){
          panelval = $('.pannel_calculator_main').attr('data-attr').trim();
          panelval = parseFloat(panelval.trim()) / 10;
        }
    
        $('.pannel_calculator__inner .pannel_calculator-width').each(function() {
            let val = parseFloat($(this).val()) || 0;
            totalValue += val;
        });
        // qty = totalValue * 0.1;
        // qty = totalValue + qty;
        qty = totalValue;
        qty = Math.ceil(qty / panelval );
      
        $('.pannel-selected-qty-value').text(qty);
    
        if (totalValue == 0) {
            if ($('.pannel_calculator_submit[disabled]').length == 0) {
                $('.pannel_calculator_submit').attr('disabled', 'disabled');
                $('.pannel-labels-cstm').addClass('hiddenn');
            }
        } else {
            if ($('.pannel_calculator_submit[disabled]').length > 0) {
                $('.pannel_calculator_submit').removeAttr('disabled');
                $('.pannel-labels-cstm').removeClass('hiddenn');
                $('.pannel-selected-variant-value').text('');
            }
            var selectedvariant = $('.product-form__input:eq(1) .product-form__radio:checked').val();
            $('.pannel-selected-variant-value').text(selectedvariant);
        }
    });    
  }

  $('.productView-variants .product-form__input input').change(function(){
    if($('.pannel-selected-variant-value').text != ''){
      var selectedvariant = $('.product-form__input:eq(1) .product-form__radio:checked').val();
      $('.pannel-selected-variant-value').text(selectedvariant);
    }
  })

  $('.pannel_calculator_submit').click(function(){
    var finalqty = $('.pannel-selected-qty-value').text().trim();
    $('.productView-form.product-form .productView-quantity input[name="quantity"]').val(finalqty);
    $('.productView-form.product-form .product-form__buttons [name="add"]').trigger('click');
  })
  
});

